module.exports = {"showDates":"Show Dates","eventSeatingReport":"Event Seating Report","transactionsSearch":"Transactions Search","checkinSystem":"Check-In System","printWillCallTicketsDymo":"Print Will Call Tickets - Dymo","printWillCallTickets":"Print Will Call Tickets - 8.5\" X 11\"","notAvailable":"Unavailable","houseCount":"House Count","unlock":"Unlock","unlocked":"Unlocked!","presale":"In presale","noPrinterAvailable":"No printer available"}


//////////////////
// WEBPACK FOOTER
// ./src/components/EventListing/Event/locales/fr.json
// module id = 1126
// module chunks = 0